import { useRef, useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, fmtErr, imgUrl } from "@/api";

export default function ImagePicker({ values = [], onChange, max = 9, testId = "image-picker" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    try {
      const next = [...values];
      for (const f of files) {
        if (next.length >= max) {
          toast.error(`Maksimal ${max} foto`);
          break;
        }
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/upload", fd);
        next.push(data.path);
      }
      onChange(next);
    } catch (err) {
      toast.error(fmtErr(err));
    }
    setBusy(false);
  };

  return (
    <div data-testid={testId}>
      <div className="grid grid-cols-3 gap-2">
        {values.map((v, i) => (
          <div key={v + i} className="relative aspect-video rounded-md overflow-hidden border border-slate-200 group">
            <img src={imgUrl(v)} alt="" className="h-full w-full object-cover" />
            <button
              type="button"
              onClick={() => onChange(values.filter((_, j) => j !== i))}
              data-testid={`${testId}-remove-${i}`}
              className="absolute top-1 right-1 h-6 w-6 rounded-full bg-black/60 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        ))}
        {values.length < max && (
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            disabled={busy}
            data-testid={`${testId}-add`}
            className="aspect-video rounded-md border-2 border-dashed border-emerald-800/30 flex flex-col items-center justify-center gap-1 text-emerald-800 hover:bg-emerald-50 transition-colors disabled:opacity-50"
          >
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <ImagePlus className="h-5 w-5" />}
            <span className="text-[10px] font-medium">{values.length}/{max}</span>
          </button>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple={max > 1} className="hidden" onChange={handleFiles} data-testid={`${testId}-input`} />
    </div>
  );
}
